import React from "react";
import styles from "./GuiasOverlay.module.scss";

// Modo guía (Fase A, bases del sistema): con ?guias=1 en la URL, superpone el centro de la lámina
// (magenta), el centro de cada columna que declare la lámina activa (celeste) y los márgenes
// seguros (amarillo, tokens --mk-margen-lateral/--mk-margen-vertical). Solo para verificar
// alineación a ojo en browser — el control exacto lo da scripts/mediakit-control.mjs.
export function GuiasOverlay({ columnas = [] }) {
  return (
    <div className={styles.overlay} data-mk-guias="1">
      <div className={`${styles.lineaV} ${styles.centro}`} style={{ left: "50%" }} />
      <div className={`${styles.lineaH} ${styles.centro}`} style={{ top: "50%" }} />

      <div className={`${styles.lineaV} ${styles.margen}`} style={{ left: "var(--mk-margen-lateral)" }} />
      <div className={`${styles.lineaV} ${styles.margen}`} style={{ right: "var(--mk-margen-lateral)" }} />
      <div className={`${styles.lineaH} ${styles.margen}`} style={{ top: "var(--mk-margen-vertical)" }} />
      <div className={`${styles.lineaH} ${styles.margen}`} style={{ bottom: "var(--mk-margen-vertical)" }} />

      {columnas.map((pct, i) => (
        <div key={i} className={`${styles.lineaV} ${styles.columna}`} style={{ left: `${pct}%` }} />
      ))}
    </div>
  );
}

export default GuiasOverlay;
